// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-c7387e72] .v-text-field input{padding:0!important}[data-v-c7387e72] .v-expansion-panel-content__wrap{padding-top:16px}[data-v-c7387e72] .v-input__slot{padding:0 12px!important}#home_secondSection[data-v-c7387e72] .v-expansion-panel-content__wrap{padding-left:10px!important;padding-right:10px!important}.ProseMirror-focused[data-v-c7387e72]{outline:none}[data-v-c7387e72] .ProseMirror{padding:10px}.sidebar[data-v-c7387e72]{z-index:7!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
